import React, { useState, useEffect, useRef } from 'react';
import "./EditProjectGroup.css"





const EditProjectGroup = ( {onClose}) => {

  return (
  <div className='EditProjectGroup_Container'>
    <div className='EditProjectGroup_TitleBox'>
    프로젝트 그룹 수정
    </div>
  
    <div className='EditProjectGroup_NameContainer'>
        <div className='EditProjectGroup_NameBox'>
            프로젝트 그룹 이름
        </div>
        <input 
            type='text' 
            className='EditProjectGroup_NameTextFelid'
            placeholder="프로젝트 그룹 이름을 입력하세요"
        />
        
        
    </div>
  
   
    <div className='EditProjectGroup__MemoContainer'>
        <div className='EditProjectGroup_NameBox'>
            프로젝트 그룹 설명
        </div>
        <input 
            type='text' 
            className='EditProjectGroup_MemoTextFelid'
            placeholder="프로젝트 그룹 설명을 입력하세요"
        />
    </div>

   
   
    <div className='EditProjectGroup_BtnContainer'>
            <div className='EditProjectGroup_Btn'>저장</div>
            <div className='EditProjectGroup_Btn' onClick={onClose}>취소</div>
        </div>
  </div>
  )}

  export default EditProjectGroup;
